module.exports = __webpack_public_path__ + "static/true-modularity-3509d72571b9868f0f13ca7da65e5acc.png";